import React from 'react';

function Datenschutz() {
  return (
    <div className="min-h-screen bg-white pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-[#1B4965] mb-8">Datenschutzerklärung</h1>
        
        <div className="prose prose-lg">
          <h2 className="text-2xl font-semibold text-[#1B4965] mt-8 mb-4">
            1. Datenschutz auf einen Blick
          </h2>
          <h3 className="text-xl font-semibold text-[#1B4965] mt-6 mb-3">
            Allgemeine Hinweise
          </h3>
          <p className="mb-4">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, 
            wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert 
            werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer Datenschutzerklärung weiter unten.
          </p>

          <h3 className="text-xl font-semibold text-[#1B4965] mt-6 mb-3">
            Datenerfassung auf unserer Website
          </h3>
          <h4 className="text-lg font-semibold text-[#1B4965] mt-4 mb-2">
            Wer ist verantwortlich für die Datenerfassung auf dieser Website?
          </h4>
          <p className="mb-4">
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum entnehmen.
          </p>

          <h4 className="text-lg font-semibold text-[#1B4965] mt-4 mb-2">
            Wie erfassen wir Ihre Daten?
          </h4>
          <p className="mb-4">
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen, z. B. durch die Eingabe in ein Kontaktformular. 
            Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. 
            Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
          </p>

          <h4 className="text-lg font-semibold text-[#1B4965] mt-4 mb-2">
            Wofür nutzen wir Ihre Daten?
          </h4>
          <p className="mb-4">
            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. 
            Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
          </p>

          <h2 className="text-2xl font-semibold text-[#1B4965] mt-8 mb-4">
            2. Hosting
          </h2>
          <p className="mb-4">
            Unsere Website wird bei <strong>Netlify</strong> gehostet. Anbieter ist Netlify, Inc., 44 Montgomery Street, 
            Suite 300, San Francisco, California 94104, USA. Netlify speichert automatisch Logfiles mit folgenden Informationen:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Browsertyp und -version</li>
            <li>Verwendetes Betriebssystem</li>
            <li>Referrer URL</li>
            <li>Hostname des zugreifenden Rechners</li>
            <li>Uhrzeit der Serveranfrage</li>
            <li>IP-Adresse</li>
          </ul>
          <p className="mb-4">
            Die Daten werden von Netlify verarbeitet, um eine sichere und effiziente Bereitstellung unserer Website zu gewährleisten. 
            Weitere Informationen finden Sie in der Datenschutzerklärung von Netlify: 
            <a href="https://www.netlify.com/privacy/" target="_blank" rel="noopener noreferrer" className="text-[#FF6B35] hover:underline">
              https://www.netlify.com/privacy/
            </a>
          </p>

          <h2 className="text-2xl font-semibold text-[#1B4965] mt-8 mb-4">
            3. Datenerfassung auf dieser Website
          </h2>
          <h3 className="text-xl font-semibold text-[#1B4965] mt-6 mb-3">
            Kontaktformular
          </h3>
          <p className="mb-4">
            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Formular inklusive der von 
            Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen gespeichert. 
            Wir nutzen <strong>Netlify Forms</strong> als Dienstleister zur Verarbeitung von Formularanfragen.
          </p>
          <p className="mb-4">
            Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der 
            Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen 
            anderen Fällen beruht die Verarbeitung auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
          </p>

          <h2 className="text-2xl font-semibold text-[#1B4965] mt-8 mb-4">
            4. Analyse-Tools und Werbung
          </h2>
          <h3 className="text-xl font-semibold text-[#1B4965] mt-6 mb-3">
            Google Search Console
          </h3>
          <p className="mb-4">
            Wir verwenden Google Search Console, einen Web-Analyse-Dienst der Google Ireland Limited, Gordon House, Barrow Street, 
            Dublin 4, Irland. Die Search Console hilft uns, die Performance unserer Website zu analysieren und Fehler zu beheben. 
            Dabei werden keine personenbezogenen Daten von Google an uns weitergegeben.
          </p>
          <p className="mb-4">
            Weitere Informationen zur Datenverarbeitung durch Google finden Sie hier: 
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#FF6B35] hover:underline">
              https://policies.google.com/privacy
            </a>
          </p>

          <h2 className="text-2xl font-semibold text-[#1B4965] mt-8 mb-4">
            5. Kommunikation via WhatsApp
          </h2>
          <p className="mb-4">
            Auf unserer Website bieten wir die Kontaktaufnahme über WhatsApp an. Hierbei wird Ihre Telefonnummer an 
            <strong>WhatsApp Ireland Limited</strong>, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland, übermittelt. 
            Die Nutzung von WhatsApp unterliegt den Datenschutzbestimmungen von WhatsApp: 
            <a href="https://www.whatsapp.com/legal/privacy-policy-eea" target="_blank" rel="noopener noreferrer" className="text-[#FF6B35] hover:underline">
              https://www.whatsapp.com/legal/privacy-policy-eea
            </a>
          </p>
          <p className="mb-4">
            Die Kommunikation über WhatsApp erfolgt nur mit Ihrer ausdrücklichen Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
          </p>

          <h2 className="text-2xl font-semibold text-[#1B4965] mt-8 mb-4">
            6. Ihre Rechte
          </h2>
          <p className="mb-4">
            Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren 
            Herkunft und Empfänger sowie den Zweck der Datenverarbeitung. Außerdem haben Sie das Recht auf Berichtigung oder 
            Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der 
            im Impressum angegebenen Adresse an uns wenden.
          </p>

          <h2 className="text-2xl font-semibold text-[#1B4965] mt-8 mb-4">
            7. Aktualisierung der Datenschutzerklärung
          </h2>
          <p className="mb-4">
            Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf anzupassen, um sie an geänderte rechtliche 
            Anforderungen oder an Änderungen unserer Dienste anzupassen.
          </p>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-semibold text-[#1B4965] mb-4">
              Verantwortlicher für die Datenverarbeitung:
            </h2>
            <p>
              Armin Breig<br />
              KFZ - Sachverständigenbüro (Einzelunternehmer)<br />
              Rosenstraße, Gebäude 5<br />
              76356 Weingarten<br />
              Telefon: +49 172 9507571<br />
              E-Mail: armin.breig@web.de
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Datenschutz;